export default "__VITE_ASSET__CxhSZbyE__"